'use client';
import { MaterialSymbol } from 'react-material-symbols';

export default function AuthLayout({ children, title, subtitle, wave }) {
  return (
    <div className="flex min-h-screen">
      <div className="zr:hidden lg:block lg:w-1/2 relative">
        <img
          src="/admin-bg.png?height=1080&width=1080"
          alt="Student studying"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
      <div className="w-full lg:w-1/2 flex justify-center px-6 py-12 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div className="mb-20">
            <img
              src="/logo.png?height=80&width=80"
              alt="School logo"
              className="h-20 w-20"
            />
            <span className="flex items-center gap-x-1">
              {title && (
                <h2 className="mt-6 mb-4 text-3xl font-medium text-[#2b2b2b]">
                  {title}
                </h2>
              )}
              {wave && (
                <MaterialSymbol
                  icon="waving_hand"
                  size={32}
                  fill
                  grade={-25}
                  color="black"
                />
              )}
            </span>
            {subtitle && (
              <p className="mt-2 text-lg text-[#a4a4a4] font-normal">
                {subtitle}
              </p>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
